module.exports = __webpack_public_path__ + "static/gallery_08-afc27ecdace10c0d03dc4ad843ddd79f.jpg";